<template>
  <div class="searchorders">
    <h1 class="subheading grey--text">Search Orders: {{ searchType }}</h1>
    <h2 class="subheading font-weight-thin grey--text">
      {{ getOrderCount() }} found
    </h2>

    <v-container class="mx-1">
      <v-text-field
        v-model="searchTerm"
        v-on:keyup="validateSearchEnter"
        label="Search Term"
        prepend-icon="search"
      ></v-text-field>
      <v-btn
        class="success mx-1"
        @click="startSearch"
        :loading="loading"
        :disabled="searchDisabled"
        ><v-icon>search</v-icon><span>Search</span></v-btn
      >
      <v-btn class="success mx-1" @click="getRecentPayments" :loading="loading"
        ><v-icon>search</v-icon><span>Recent</span></v-btn
      >
      <v-btn class="success mx-1" @click="getPendingPayments" :loading="loading"
        ><v-icon>search</v-icon><span>Pending payments</span></v-btn
      >

      <v-expansion-panels class="py-3">
        <v-expansion-panel v-for="order in ordersFound" :key="order.cartId">
          <v-expansion-panel-header
            v-on:click="setCartId(order.cartId)"
            class="py-1"
          >
            <v-row class="py-0">
              <v-col cols="6"> {{ order.cartId }} </v-col>
              <v-col cols="6">
                <div v-if="order.email" class="font-weight-bold">
                  Email: {{ order.email }}
                  <span class="caption"
                    ><v-icon
                      size="15"
                      v-on:click.stop="copyEmailToClipboard(order.email)"
                      >content_copy</v-icon
                    ></span
                  >
                </div>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-card class="px-4 grey--text">
              <v-row>
                <v-col cols="4 packed">
                  <div>Order Date: {{ order.orderDate }}</div>
                </v-col>
                <v-col cols="4 packed">
                  <div>Confirmed Date: {{ order.confirmDate }}</div>
                </v-col>
                <v-col cols="4 packed">
                  <div>Sent Date: {{ order.sentDate }}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4 packed">
                  <div>Order net Cost: {{ order.netCost.price }}</div>
                </v-col>
                <v-col cols="4 packed">
                  <div>Order shipping cost: {{ order.shipping.price }}</div>
                </v-col>
                <v-col cols="4 packed">
                  <div>Order total cost: {{ order.totalCost.price }}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6 packed">
              <div>Status: {{ order.status }}</div>
                </v-col>
                <v-col cols="6 packed">
              <div>Shipping info: {{ order.shipping.weight }}g {{ order.shipping.packaging }}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12 packed">
              <div>
                Address: {{ order.customerAddress }}
                <span class="caption"
                  ><v-icon
                    size="15"
                    @click="copyAddressToClipboard(order.customerAddress)"
                    >content_copy</v-icon
                  ></span
                >
              </div>
                </v-col>
              </v-row>
                <div
                    v-for="cartitem in cartContents.cart"
                    :key="cartitem.id"
                    class="px-6 my-3"
                  >
                    <v-row>
                        {{ cartitem.item }} - {{ cartitem.description }} ({{
                          cartitem.price
                        }})
                    </v-row>
                  </div>
                <v-row>
                <PendingPaymentDialog
                  v-bind:cartId="cartId"
                  @paymentSet="getPendingPayments"
                />
                <v-btn
                  absolute
                  right
                  class="primary"
                  @click="copyCartIdToClipboard"
                >
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
              </v-row>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";
import PendingPaymentDialog from "../components/PendingPaymentDialog";
import { store } from "../store.js";

export default {
  components: { PendingPaymentDialog },
  data() {
    return {
      searchType: "",
      searchTerm: "",
      ordersFound: [],
      cartId: "",
      cartContents: [],
      loading: false,
    };
  },
  methods: {
    async validateSearchEnter(e) {
      if (e.keyCode == 13) {
        if (this.searchTerm.length > 3) {
          this.startSearch();
        }
      }
    },
    async startSearch() {
      this.loading = true;
      this.ordersFound = [];
      this.ordersFound = await cartApi.getPaymentsByName(this.searchTerm);
      this.searchType = this.searchTerm;
      this.loading = false;
    },
    async getPendingPayments() {
      this.loading = true;
      this.ordersFound = [];
      this.ordersFound = await cartApi.getPendingPayments();
      this.searchType = "Pending payments";
      this.loading = false;
    },
    async getRecentPayments() {
      this.loading = true;
      this.ordersFound = [];
      this.ordersFound = await cartApi.getRecentPayments();
      this.searchType = "Recent payments";
      this.loading = false;
    },
    async setCartId(cartId) {
      this.cartId = cartId;
      this.cartContents = await cartApi.getCart(cartId);
    },
    getOrderCount() {
      return this.ordersFound.length;
    },
    async copyCartIdToClipboard() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.cartId).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied cartId " + this.cartId);
      store.storeCartId(this.cartId);
    },
    async copyEmailToClipboard(email) {
      let copyRes = false;
      await navigator.clipboard.writeText(email).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied email " + email);
    },
    async copyAddressToClipboard(address) {
      let copyRes = false;
      await navigator.clipboard.writeText(address).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied address");
    },
  },
  computed: {
    searchDisabled() {
      return this.searchTerm.length < 4;
    },
    getTotalCost() {
      return order.price;
    },
  },
};
</script>

<style>
.packed {
  /*  color: red; */
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
